import { useAtomValue, useSetAtom } from 'jotai'
import type { PlanId, RestaurantId } from '~/lib/graphql/scalars'
import { favoriteState$, togglePlanFavorite$ } from './atoms'

/** 与えられたプランのお気に入り状態を返す */
export function useFavoriteState(restaurantId: RestaurantId, planId: PlanId) {
  return useAtomValue(favoriteState$({ restaurantId, planId }))
}

/** 与えられたプランをお気に入り状態を更新する */
export function useTogglePlanFavorite(restaurantId: RestaurantId, planId: PlanId) {
  const set = useSetAtom(togglePlanFavorite$)
  return set({ restaurantId, planId })
}
